const useUserInitialStates = () => {
  const userInitialState = {};

  return {
    userInitialState
  }
};

export default useUserInitialStates;